import { InputHTMLAttributes } from 'react'

import { CustomRadioCont } from './style'
import { FlexRow } from 'styles/styled'

interface ICustomRadioInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
}

const CustomRadioInput = (props: ICustomRadioInputProps) => {
  const { label, id, ...otherProps } = props
  const isChecked = otherProps?.checked
  return (
    <FlexRow gap='10px' as='label' htmlFor={id}>
      <CustomRadioCont>
        <input
          name='radio'
          id={id}
          type='radio'
          {...otherProps}
          checked={isChecked}
        />
        <p>{label}</p>
      </CustomRadioCont>
    </FlexRow>
  )
}

export default CustomRadioInput
